import { message } from 'antd';
import type { MessageInstance } from 'antd/es/message/interface';

import { handleApiError } from '../services/errorHandler';

export const ERROR_DURATION_SEC = 5;
export const SUCCESS_DURATION_SEC = 3;
export const LONG_MESSAGE_THRESHOLD = 120;

export function resolveErrorMessage(error: unknown, fallback?: string): string {
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }

  try {
    return handleApiError(error).message;
  } catch {
    return fallback ?? 'Erro desconhecido. Tente novamente mais tarde.';
  }
}

function createStaticMessageApi(): ReturnType<typeof bindStaticApi> {
  return bindStaticApi(message);
}

function bindStaticApi(msg: MessageInstance) {
  return {
    showError(error: unknown, fallback?: string): void {
      const content = resolveErrorMessage(error, fallback);
      console.error('appMessage.showError:', error);
      const duration = content.length > LONG_MESSAGE_THRESHOLD ? 0 : ERROR_DURATION_SEC;
      msg.error({ content, duration });
    },

    showSuccess(content: string): void {
      msg.success({ content, duration: SUCCESS_DURATION_SEC });
    },

    showWarning(content: string): void {
      msg.warning({ content, duration: ERROR_DURATION_SEC });
    },

    showInfo(content: string): void {
      msg.info({ content, duration: SUCCESS_DURATION_SEC });
    },
  };
}

/** Fallback estático (interceptors, fora de React). Preferir `useAppMessage()` em componentes. */
export const appMessage = createStaticMessageApi();

export default appMessage;
